export default __webpack_public_path__ + "static/media/icon_github.b32ef956.png";